import React, { Component } from "react"
import { ControlLabel, FormControl, FormGroup } from "react-bootstrap"

export default class FormTextWrapper extends Component {
	propTypes: {
		id: React.PropTypes.string.isRequired,
		defaultValue: React.PropTypes.string,
		placeholder: React.PropTypes.string,
		maxLength: React.PropTypes.number,
		disabled: React.PropTypes.bool,
		extraClassNameFormGroup: React.PropTypes.string,
		helperText: React.PropTypes.string,
	}

	constructor(props) {
		super(props)
		const { defaultValue } = this.props
		this.state = {
			value: defaultValue || "",
		}
	}

	handleChange = e => {
		let value = e.target.value
		value = value.trim()
		if (value.startsWith("Key:")) {
			value = value.slice(4)
		} else if (value.startsWith("Secret:")) {
			value = value.slice(7)
		}
		this.setState({ value })
	}

	getData() {
		return this.state.value
	}

	render() {
		const {
			id,
			label,
			defaultValue,
			placeholder,
			maxLength,
			disabled,
		} = this.props
		return (
			<FormGroup>
				<ControlLabel>{label}</ControlLabel>
				<FormControl
					id={id}
					name={id}
					value={this.state.value}
					type="text"
					disabled={disabled}
					className="form-control"
					defaultValue={defaultValue}
					placeholder={placeholder}
					onChange={this.handleChange}
					maxLength={maxLength}
					ref="localValue"
				/>
			</FormGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/forms/FormTextWrapper.js